import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useChatSettings } from '@guuru/chat-web';
import { setTranslations } from '@guuru/translation-web';

const useSetLanguage = (partnerId: string) => {
  const { i18n } = useTranslation();
  const { data, loading: isLoading } = useChatSettings(partnerId);

  const { language, translations } = data?.chatSettings ?? {};

  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (isLoading || !language || !translations) return () => {};

    const load = async () => {
      if (i18n.language !== language) {
        await i18n.changeLanguage(language);
      }
      if (cancelled) return;
      setTranslations(language, translations);
      setReady(true);
    };

    load();

    return () => {
      cancelled = true;
    };
  }, [isLoading, language, translations, i18n]);

  return {
    loading: isLoading || !ready,
  };
};

export default useSetLanguage;
